<template>
  <section id="homeAddress">
    <div class="container">
      <div class="header">
        <h5>{{stateName}}</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off">
        <h5>
          Great! Hi {{person}}
          <br>Just a few more items...
        </h5>
        <div class="columns">
          <div class="column is-two-thirds">
            <div class="control streetAddress">
              <label for="streetAddress">
                Street Address
                <span>*</span>
              </label>
              <input
                v-model="selectedAddress"
                v-validate="'required'"
                id="streetAddress"
                class="input"
                ref="autocomplete"
                type="text"
                placeholder="We want to find your nearest store"
                required
              >
            </div>
          </div>
        </div>
        <div class="columns penCol">
          <div class="column is-one-third">
            <div class="question">
              <p>Can we send your ShavesPaintBucks™ updates via email?</p>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input v-model="balance" type="radio" id="balanceYes" value="yes">
                <label for="balanceYes">Yes Please</label>

                <input v-model="balance" type="radio" id="balanceNo" value="no">
                <label for="balanceNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="question m-0">
              <p>Would you like to hear about our great specials and promotions?</p>
              <small>We promise we won't spam you</small>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input v-model="promotions" type="radio" id="specialsYes" value="yes">
                <label for="specialsYes">Yes Please</label>

                <input v-model="promotions" type="radio" id="spacialsNo" value="no">
                <label for="spacialsNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-thirds">
            <div class="termsAndConditions">
              <div class="checkBox">
                <input
                  v-validate="'required'"
                  v-model="TandC"
                  type="checkbox"
                  name="TandC"
                  id="TandC"
                >
                <span class="checkmark"></span>
              </div>
              <p>
                I agree to the
                <a @click="openTermsAndConditions">terms and conditions</a> specified.
              </p>
            </div>
          </div>
        </div>
      </form>

      <div class="actions">
        <button @click="back" class="button is-white">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toContactInfo" class="button is-blue">Continue</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";

export default {
  name: "individualaddress",
  components: {
    CancelButton
  },
  data() {
    return {
      stateName: "",
      streetAddress: null,
      selectedAddress: null,
      TandC: null,
      balance: "yes",
      promotions: "yes"
    };
  },
  methods: {
    toContactInfo() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$gtag.event('promotions_newsletter', {
            'event_category': 'engagement',
            'event_label': this.promotions,
            'value': ''
          });
          this.$gtag.event('send_balance', {
            'event_category': 'engagement',
            'event_label': this.balance,
            'value': ''
          });
          this.$store.commit("SAVE_PERSONAL_ADDRESS", {
            address: this.selectedAddress,
            TandC: this.TandC,
            balanceMail: this.balance,
            promotionMail: this.promotions
          });
          this.$router.push("/loyaltycard");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
    openTermsAndConditions() {
      document.body.classList.add("showTermsAndConditions");
    }
  },
  created() {
    if (this.$store.state.loyaltyType == "personal") {
      this.stateName = "Home Improver";
    } else {
      this.stateName = "Pension Home Improver";
    }
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      {
        types: ["geocode"]
      }
    );
    this.autocomplete.setComponentRestrictions({ country: ["za"] });

    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      this.selectedAddress = place.formatted_address;
    });
    if(this.$store.state.personal.address.balanceMail != undefined){
        this.selectedAddress = this.$store.state.personal.address.address
        this.TandC = this.$store.state.personal.address.TandC
        this.balance = this.$store.state.personal.address.balanceMail
        this.promotions = this.$store.state.personal.address.promotionMail
        console.log("setting values")
    }

  },
  computed: {
    person() {
      return this.$store.state.personal.info.firstName;
    }
  }
};
</script>